import React from 'react';
import { useSelector } from 'react-redux';
import { selectInnerSidebarVisible } from '../../features/ui/uiSlice';
import styles from './MainLayout.module.scss';

/**
 * MainLayout - Centralized layout component that handles InnerSidebar visibility
 * and automatically adjusts content positioning for all pages
 */
export const MainLayout = ({ children }) => {
    const isInnerSidebarVisible = useSelector(selectInnerSidebarVisible);

    return (
        <div className={`${styles['main-layout']} ${isInnerSidebarVisible ? styles['inner-sidebar-visible'] : ''}`}>
            {children}
        </div>
    );
};
